import {
  Avatar,
  Box,
  Card,
  CardMedia,
  Chip,
  Stack,
  SxProps,
  Typography,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"
import { CustomIcon, ShopIcon } from "components/icons"
import { useTranslation } from "providers/i18n"

interface ImageCardProps {
  sx?: SxProps
  id: string | number
  coverImage?: string
  logoSrc?: string
  iconPath?: string
  primaryText: string
  secondaryText?: string
  adornmentText: string
  isFeatured: boolean
  isSection: boolean
  onClick: () => void
}

export const OccupantImageCard = ({
  sx,
  id,
  coverImage,
  logoSrc,
  iconPath,
  primaryText,
  secondaryText,
  adornmentText,
  isFeatured,
  isSection,
  onClick,
  ...restProps
}: ImageCardProps) => {
  const { t } = useTranslation()

  const theme = useTheme()
  const {
    root,
    header,
    chipContainer,
    zoneChip,
    highlightChip,
    headerCover,
    contentContainer,
    logo,
    icon,
    textContainer,
    title,
    subtitleContainer,
    subtitle,
    adornmentContainer,
    adornment,
  } = theme.components[`OccupantImageCard`]?.styleOverrides || {}

  return (
    <Card
      className={isSection ? "section-card" : ""}
      sx={deepmerge(root, sx)}
      onClick={onClick}
      {...restProps}
    >
      <Box sx={header}>
        <Box sx={chipContainer}>
          {isSection && <Chip sx={zoneChip} label={t("Zone")} />}
          {isFeatured && <Chip label={t("Highlight")} sx={highlightChip} />}
        </Box>
        <CardMedia sx={headerCover} component="img" image={coverImage} />
      </Box>
      <Box sx={contentContainer} className="OccupantImageCard-contentContainer">
        <Box sx={adornmentContainer}>
          <Box sx={adornment} className="OccupantImageCard-levelContainer">
            <Typography variant="h6">{adornmentText}</Typography>
          </Box>
        </Box>
        <Box sx={logo} className="OccupantImageCard-logo">
          <Avatar src={logoSrc} variant="square">
            {iconPath ? (
              <CustomIcon sx={icon} path={iconPath} fontSize="inherit" />
            ) : (
              <ShopIcon fontSize="inherit" />
            )}
          </Avatar>
        </Box>
        <Stack direction="column" sx={textContainer}>
          <Typography sx={title} className="OccupantImageCard-title">
            {primaryText}
          </Typography>
          {secondaryText && (
            <Stack
              direction="column"
              sx={subtitleContainer}
              className="OccupantImageCard-subtitleContainer"
            >
              <Typography variant="body2" sx={subtitle}>
                {secondaryText}
              </Typography>
            </Stack>
          )}
        </Stack>
      </Box>
    </Card>
  )
}
